module.exports = __webpack_public_path__ + "static/media/screenshot-geo.298886a1.png";